// services/project.services.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IProject } from "../projectModal";

export const getAllProjects = createAsyncThunk(
  "Project/FindAllProject",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Project/FindAllProject`,
        {
          Title: "",
          PropertyTypeName: "",
          PropertyStatusName: "",
          AreaName: "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Projects:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createProject = createAsyncThunk(
  "Project/InsertProject",
  async (projectData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Project/InsertProject`,
        projectData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Project:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateProject = createAsyncThunk(
  "Project/UpdateProject",
  async (projectData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Project/UpdateProject`,
        projectData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Project:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteProject = createAsyncThunk(
  "Project/DeleteProject",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Project/DeleteProject`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Project:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getProjectByID = createAsyncThunk(
  "Project/FindByIDProject",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Project/FindByIDProject`,
        { ID },
      );
      const result = response.data?.Data;
      return {
        ID: result?.ID,
        Title: result?.Title,
        URL: result?.URL,
        Tagline: result?.Tagline,
        PropertyTypeID: result?.PropertyTypeID,
        PropertyStatusID: result?.PropertyStatusID,
        AreaID: result?.AreaID,
        ShortDescription: result?.ShortDescription,
        LongDescription: result?.LongDescription,
        SquareFoot: result?.SquareFoot,
        PriceRange: result?.PriceRange,
        SequenceNo: result?.SequenceNo,
        IsDisplayInHome: result?.IsDisplayInHome || false,
        MetaTitle: result?.MetaTitle,
        MetaKeywords: result?.MetaKeywords,
        MetaDescription: result?.MetaDescription,
        MainImage: result?.MainImage,
        BannerImage: result?.BannerImage,
        IsActive: result?.IsActive ? 1 : 2,
      } as IProject;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Project:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getProjectByURL = createAsyncThunk(
  "Project/FindByURLProject",
  async (URL: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Project/FindByURLProject`,
        { URL },
      );
      const result = response.data?.Data as IProject;
      return result;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Project by URL:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveProjects = createAsyncThunk(
  "Project/FindAllActiveProject",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Project/FindAllActiveProject`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Active Projects:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const activeInactiveProject = createAsyncThunk(
  "Project/ActiveInActiveProject",
  async (formData: { ID: number; IsActive: boolean }) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Project/ActiveInActiveProject`,
        formData,
      );
      SuccessToast(response.data?.Details || "Status updated successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Project:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const projectImageUpload = createAsyncThunk(
  "Project/SingleImageUpload",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Project/SingleImageUpload`,
        formData,
        { headers: { "content-type": "multipart/form-data" } },
      );
      SuccessToast(response.data?.Details || "Images uploaded successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error uploading Project images:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
